import { BlockEvent, IEventPayload } from './BlockEvent'
import { IMemoryGameCompletedEventPayload, memoryGameCompletedEvent, memoryGameStartedEvent } from './memoryEvents'
import { IPuzzleGameCompletedEventPayload, puzzleGameCompletedEvent, puzzleGameStartedEvent } from "./puzzleEvents"

export const blockEvents = [
    new BlockEvent<IEventPayload>(memoryGameStartedEvent),
    new BlockEvent<IMemoryGameCompletedEventPayload>(memoryGameCompletedEvent),
    new BlockEvent<IEventPayload>(puzzleGameStartedEvent),
    new BlockEvent<IPuzzleGameCompletedEventPayload>(puzzleGameCompletedEvent)
]